/* eslint-disable @typescript-eslint/no-explicit-any */
import { BayLevelEnum, ForeAftEnum } from "open-vessel-definition";
import { pad3, sortByMultipleFields } from "@tedivo/tedivo-pure-helpers";
import { getSizesFromSlots } from "./getSizesFromSlots";
export function getAllThePairedBays(bls, checkOnly40s) {
    const pairedBays = [];
    const unpairedBays = [];
    const has40Fn = (bl) => {
        return Object.keys(bl.perSlotInfo || {}).some((slot) => {
            var _a, _b;
            return Object.keys(((_b = (_a = bl.perSlotInfo) === null || _a === void 0 ? void 0 : _a[slot]) === null || _b === void 0 ? void 0 : _b.sizes) || {})
                .map(Number)
                .some((size) => size >= 40);
        });
    };
    const getDefinedSlots = (bl) => getSizesFromSlots(bl.perSlotInfo).definedSlots;
    const getMaxSize = (bl) => {
        const sizes = getSizesFromSlots(bl.perSlotInfo).sizes;
        return sizes.length ? Math.max(...sizes) : 0;
    };
    [BayLevelEnum.ABOVE, BayLevelEnum.BELOW].forEach((level) => {
        const bays = bls
            .filter((a) => a.level === level)
            .sort(sortByMultipleFields([{ name: "isoBay", ascending: true }]));
        for (let i = 0; i < bays.length; i++) {
            const bay = bays[i];
            let has40 = true;
            if (checkOnly40s) {
                has40 = has40Fn(bay);
            }
            if (bay.pairedBay === ForeAftEnum.AFT) {
                const nextBay = bays[i + 1];
                if (nextBay && nextBay.pairedBay === ForeAftEnum.FWD) {
                    const baysPrefixes = new Set();
                    for (let j = Number(bay.isoBay); j <= Number(nextBay.isoBay); j++) {
                        baysPrefixes.add(pad3(j));
                    }
                    pairedBays.push({
                        base: bay.isoBay,
                        paired: nextBay.isoBay,
                        has40: getMaxSize(bay) >= 40,
                        level: level,
                        allBays: [bay.isoBay, nextBay.isoBay],
                        baysPrefixes,
                    });
                    i++;
                }
                else {
                    if (has40 || !checkOnly40s)
                        unpairedBays.push({
                            base: bay.isoBay,
                            level: level,
                            has40: getMaxSize(bay) >= 40,
                            allBays: [bay.isoBay],
                            definedSlots: getDefinedSlots(bay),
                        });
                }
            }
            else {
                if (has40 || !checkOnly40s)
                    unpairedBays.push({
                        base: bay.isoBay,
                        level: level,
                        has40: getMaxSize(bay) >= 40,
                        allBays: [bay.isoBay],
                        definedSlots: getDefinedSlots(bay),
                    });
            }
        }
    });
    const pairedBaysPer20Bay = [...pairedBays, ...unpairedBays].reduce((acc, pb) => {
        const [base, paired] = pb.allBays;
        const level = pb.level;
        if (!paired) {
            acc[`${base}-${level}`] = undefined;
        }
        else {
            acc[`${base}-${level}`] = paired;
            acc[`${paired}-${level}`] = base;
        }
        return acc;
    }, {});
    return { pairedBays, unpairedBays, pairedBaysPer20Bay };
}
